import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';

const LoadingModal = ({ 
loadingMessage,
loadingProgress
 }) => {


return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 backdrop-blur-md">
<div className="bg-white rounded-lg max-w-md w-full p-8">
<div className="text-center">
<div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
<Brain className="w-8 h-8 text-purple-600 animate-pulse" />
</div>
<h3 className="text-xl font-bold text-gray-900 mb-2">Setting Up Your Mock Interview</h3>
<p className="text-gray-600 mb-6">{loadingMessage}</p>

<div className="w-full bg-gray-200 rounded-full h-2 mb-2">
<div
className="bg-purple-600 h-2 rounded-full transition-all duration-500"
style={{ width: `${loadingProgress}%` }}
></div>
</div>
<p className="text-sm text-gray-500">{Math.round(loadingProgress)}%</p>
</div>
</div>
</div>
);
};

export default LoadingModal;